import { Phone, MapPin, Instagram } from 'lucide-react';
import { Link } from 'react-router-dom';

export const Footer = () => {
  return (
    <footer className="bg-[#121212] border-t border-neutral-800 py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          {/* Brand */}
          <div className="md:col-span-1">
            <h3 className="text-2xl font-bold text-[#D4AF37] mb-4">Magic Touch</h3>
            <p className="text-[#A3A3A3] text-sm">
              Premium Unisex Hair Studio in Kandivali, Mumbai
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-semibold mb-4 uppercase tracking-wider text-sm">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-[#A3A3A3] hover:text-[#D4AF37] transition-colors text-sm">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-[#A3A3A3] hover:text-[#D4AF37] transition-colors text-sm">
                  Services
                </Link>
              </li>
              <li>
                <Link to="/gallery" className="text-[#A3A3A3] hover:text-[#D4AF37] transition-colors text-sm">
                  Gallery
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-[#A3A3A3] hover:text-[#D4AF37] transition-colors text-sm">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-white font-semibold mb-4 uppercase tracking-wider text-sm">Contact</h4>
            <ul className="space-y-3">
              <li className="flex items-start space-x-2">
                <Phone className="text-[#D4AF37] flex-shrink-0 mt-0.5" size={16} />
                <div className="flex flex-col space-y-1">
                  <a href="tel:+919870214490" className="text-[#A3A3A3] hover:text-[#D4AF37] transition-colors text-sm">
                    +91 98702 14490
                  </a>
                  <a href="tel:+918828817070" className="text-[#A3A3A3] hover:text-[#D4AF37] transition-colors text-sm">
                    +91 88288 17070
                  </a>
                </div>
              </li>
              <li className="flex items-start space-x-2">
                <MapPin className="text-[#D4AF37] flex-shrink-0 mt-0.5" size={16} />
                <span className="text-[#A3A3A3] text-sm">
                  Thakur Complex, Kandivali East, Mumbai
                </span>
              </li>
            </ul>
          </div>

          {/* Social Media */}
          <div>
            <h4 className="text-white font-semibold mb-4 uppercase tracking-wider text-sm">Follow Us</h4>
            <a
              href="https://www.instagram.com/magictouchhairstudio/"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-instagram-link"
              className="inline-flex items-center space-x-2 bg-neutral-900 border border-neutral-800 px-4 py-2 hover:border-[#D4AF37] transition-colors group"
            >
              <Instagram className="text-[#D4AF37] group-hover:scale-110 transition-transform" size={20} />
              <span className="text-[#A3A3A3] group-hover:text-[#D4AF37] transition-colors text-sm">
                @magictouchhairstudio
              </span>
            </a>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-neutral-800 pt-8 text-center">
          <p className="text-[#A3A3A3] text-sm">
            © 2025 Magic Touch Unisex Hair Studio. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};
